import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from "./../editor-common";
import EmojiPluginIcon from "./icons/EmojiPluginIcon";
import InsertModal from "./modals/InsertModal";
import { EMOJI_TYPE, emojiModals } from "./types";
const toolbarsToAddIn = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE
];
const getAddButtons = (_config, services) => {
  const {
    context: { isMobile = false }
  } = services || {};
  return isMobile ? [] : [
    {
      id: EMOJI_TYPE,
      label: INSERT_PLUGIN_BUTTONS.EMOJI,
      dataHook: INSERT_PLUGIN_BUTTONS.EMOJI,
      icon: EmojiPluginIcon,
      tooltip: "EmojiPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: () => true,
      modal: {
        id: emojiModals.insert,
        Component: InsertModal
      },
      menuConfig: {
        tags: "Emoji_plugin_search_tags"
      }
    }
  ];
};
export {
  getAddButtons,
  toolbarsToAddIn
};
//# sourceMappingURL=getAddButtons.js.map
